module.exports = __webpack_public_path__ + "static/media/pics12.1993b6e7.png";